import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../services/apiClient';
import { Page, Size } from "../../config/config";
let CurrentPage = Number(Page);
export const fetchAllContacts = createAsyncThunk(
  'contact/fetchAllContacts',
  async (Param: any, { rejectWithValue }) => {
    try {
      CurrentPage = Param.NextPage
      const response = await apiClient.get(`Contacts/GetCommunicationContacts/` + CurrentPage + "/" + Size, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'mode': 'outlook'
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const contactSlice = createSlice({
  name: 'contacts',
  initialState: {
    contacts: [],
    loading: false,
    error: null,
    page: 1,
    pageCount: 1,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllContacts.pending, (state) => {
        state.loading = true;
        state.error = null;
        // state.contacts = null;
        // //state.contacts = action.payload.data;
        // state.pageCount = 0;
        // state.page = 0;
      })
      .addCase(fetchAllContacts.fulfilled, (state, action) => {
        state.loading = false;

        // Page 1 REPLACES, later pages append. This previously always
        // appended (Array.prototype.push.apply), with no page-1 reset - so
        // any refetch of the contact list (item change, re-login, a second
        // pass through the BaseComponent login effect) silently appended a
        // whole second copy on top of the existing one. That doubled both
        // the To/Cc option count and the render cost, and produced visible
        // duplicate entries. matterSlice already had this guard.
        if (action.payload.page === 1) {
          state.contacts = action.payload.data;
        } else {
          state.contacts = [...state.contacts, ...action.payload.data];
        }

        state.pageCount = action.payload.pageCount;
        state.page = action.payload.page;

        // Sort ONCE, when the final page lands - not on every page.
        // Sorting here per-page meant re-sorting a growing array ~40 times
        // for a 100k contact list, each pass paying for localeCompare (one
        // of the slowest string operations in JS). Nothing reads this list
        // in a user-visible way before the run completes: the dropdowns are
        // blocked while `page < pageCount` (see EmailLog.tsx).
        if (action.payload.page >= action.payload.pageCount) {
          state.contacts.sort((a, b) =>
            (a.firstName + " " + a.lastName).toLowerCase().localeCompare((b.firstName + " " + b.lastName).toLowerCase()));
        }
      })
      .addCase(fetchAllContacts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default contactSlice.reducer;
